<template>
    <div class="item" :class="catalogueItemClass()" @mouseover="onHoverProduct('enter');" @mouseleave="onHoverProduct('leave');">
        <div class="item full center txtCenter">
            <div class="preview">
                <ComponentPreview :component="item"></ComponentPreview>
                <h3 class="rel">
                    <span class="ff-bold uppercase second-text">
                        <i v-if="item.isStar" class="fas fa-star fa-1x pointer" :style="{ color: colors.color4 }"></i>
                        {{ getTranslate(item.terms.name) }}
                    </span>
                    <br />
                </h3>
            </div>
        </div>
        <!-- mobile cannot access to the component details -->
        <transition name="fade" v-if="device != 'mobile'">
            <router-link :to="'/' + item.type + '/' + item.id">
                <div class="roll-over box-overlay flexContainer full" v-if="rollIndex === index">
                    <div class="txtCenter center">
                        <div class="hoverDetails">
                            <h4 class="ff-medium uppercase">
                                <i v-if="item.isStar" class="fas fa-star fa-1x pointer" :style="{ color: colors.color4 }"></i>
                                {{ getTranslate(item.terms.name) }}
                            </h4>
                            <p class="ff-light uppercase" v-if="item.infosArticle.hasOwnProperty('client_ref1')">
                                {{ item.infosArticle.client_ref1.componentProperty.value }}
                            </p>
                            <p class="ff-light uppercase" v-if="item.infosArticle.hasOwnProperty('diam_ref1')">
                                {{ item.infosArticle.diam_ref1.componentProperty.value }}
                            </p>
                            <div class="btn-hover txtCenter" v-if="page == 'catalogue' && device != 'mobile'">
                                <span
                                    v-if="item.type == 'module' || item.type == 'product'"
                                    @click.prevent.stop="addWishList();"
                                    @mouseenter.prevent.stop="visibleinfo"
                                    @mouseleave.prevent.stop="hideinfo"
                                >
                                    <i class="far fa-file-pdf fa-lg"></i>
                                </span>

                                <span
                                    @click.prevent.stop="openAddBasket();"
                                    @mouseenter.prevent.stop="visibleBinfo"
                                    @mouseleave.prevent.stop="hideBinfo"
                                    class="basket iLineBlock"
                                    v-if="
                                        item.prices.find(p => p.zone.id === currentZoneId) != null &&
                                            item.type !== 'product' &&
                                            hasAccessRead('orders_manager')
                                    "
                                >
                                    <i class="fas fa-shopping-basket fa-lg"></i>
                                </span>
                                <span
                                    @click.prevent.stop="displayForecastModal = true;"
                                    @mouseenter.prevent.stop="displayForecast = true;"
                                    @mouseleave.prevent.stop="displayForecast = false;"
                                    class="basket iLineBlock"
                                    v-if="canAddToForecast() && hasAccessDelete(forecastFunctionality)"
                                >
                                    <ForecastIcon style="height: 20px; margin-bottom: -2px" />
                                </span>
                                <br />
                                <span class="info-export-pdf" v-if="displayinfo" :class="{ invisible: !displayinfo }">
                                    {{ $t("catalogue.exportpdf") }}
                                </span>
                                <span class="info-export-pdf" v-if="displayBasketinfo" :class="{ invisible: !displayBasketinfo }">
                                    {{ $t("catalogue.basket") }}
                                </span>
                                <span class="info-export-pdf" v-if="displayForecast"> Add to Forecast </span>
                            </div>
                        </div>
                    </div>
                </div>
            </router-link>
        </transition>
        <ForecastItemModal v-if="displayForecastModal" :item="item" @close="displayForecastModal = false;" />
    </div>
</template>

<script>
import ComponentPreview from "@/catalog/component-preview";
import Globals from "../globals.js";
import { mapActions, mapGetters } from "vuex";
import { centerToBottomLeft } from "@/catalog/caddy-utils";
import cacheService from "@/services/cache";
import { FUNCTIONALITY as forecastFunctionality } from "@/components/forecasts/constants";
import ForecastIcon from "@/components/forecasts/elements/icons/ForecastIcon";
import ForecastItemModal from "@/components/forecasts/elements/catalogue/Modal";
import { canAddItemToAtLeastOneForecast } from "@/components/forecasts/validation/forecastValidator";

export default {
    name: "ComponentListItem",
    components: { ForecastItemModal, ComponentPreview, ForecastIcon },
    props: ["item", "device", "index", "page"],
    data() {
        return {
            colors: cacheService.getBrandColors(),
            currentZoneId: cacheService.getCurrentZoneId(),
            rollIndex: null,
            displayBasket: false,
            displayBasketinfo: false,
            displayinfo: false,
            displayForecast: false,
            displayForecastModal: false,
            forecastFunctionality
        };
    },
    computed: {
        ...mapGetters("module/status", ["getStatusColor"]),
        ...mapGetters("forecast", { forecasts: "updatable" }),
        caddyConfig() {
            return centerToBottomLeft(this.item.config);
        }
    },
    methods: {
        ...mapActions({
            toAddList: "catalog/wishlist/toAddList",
            setDisplay: "catalog/wishlist/setDisplay",
            setModeWishList: "catalog/wishlist/setMode",
            setBasketItemComponent: "ordersStore/setBasketItemComponent"
        }),
        onHoverProduct(action) {
            if (this.device === "desktop") {
                if (action === "enter") {
                    this.rollIndex = this.index;
                } else {
                    this.rollIndex = null;
                }
            }
        },
        catalogueItemClass() {
            // let numberItems = this.device === "mobile" ? 2 : 3;
            return [
                // (this.index + 1) % numberItems ? "bordered" : "",
                // this.index + 1 <= numberItems ? "firstRow" : "secondRow",
                !this.item.is_published ? "isNotPublished" : "",
                // this.page === "catalogue" ? (this.device === "desktop" ? "size1of4" : "size1of2") : "size1of3",
                this.page === "catalogue" ? (this.device === "desktop" ? "col-lg-3 col-md-3" : "col-sm-12") : "col-lg-4 col-md-4 col-xs-6",
                this.rollIndex === this.index || this.rollIndex === this.index + 1 ? "hover-parent" : ""
            ];
        },
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        },
        openAddBasket() {
            this.$parent.displayBasket = true;
            this.setBasketItemComponent(this.item);
        },
        canAddToForecast() {
            return canAddItemToAtLeastOneForecast(this.forecasts, this.item);
        },
        modalClose(close) {
            this.$parent.displayBasket = false;
        },
        visibleinfo() {
            this.displayinfo = true;
        },
        hideinfo() {
            this.displayinfo = false;
        },
        visibleBinfo() {
            this.displayBasketinfo = true;
        },
        hideBinfo() {
            this.displayBasketinfo = false;
        },
        addWishList() {
            this.setModeWishList("add");
            let comp = {
                id: this.item.id,
                images: this.item.figures_advanced,
                name: this.item.terms.name,
                type: this.item.type
            };
            this.toAddList(comp);
            this.setDisplay(true);
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.hoverDetails {
    height: 150px;
}
.item {
    font-size: 1.4rem;
    margin-bottom: 25px;

    .component-preview {
        padding-bottom: 216px;
    }

    .catalogueImg {
        border: 1px solid #ccc;
        overflow: hidden;
        .dark & {
            background: white;
        }
        img {
            max-height: 200px;
            max-width: 100%;
        }
    }
    &.firstRow,
    &.secondRow {
        margin-bottom: 20px;
    }
    &.bordered {
        border-right: 1px solid #ccc;
    }
    &.hover-parent {
        border-color: transparent;
    }
    .roll-over {
        z-index: 3;
        border-radius: 5px;
        font-size: 1.4rem;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        div {
            max-width: 230px;
            display: block;
            margin: auto;
            padding-top: 15px;
        }
        .btn-hover {
            bottom: 10px;
            span {
                display: inline-block;
                padding: 5px;
            }
        }
        p {
            margin: 5px 0;
        }
        h4 {
            margin-bottom: 5px;
        }
        .btn {
            background: transparent;
            border-radius: 2em;
            border: 1px solid #343434;
            padding: 0.65em 1.7em;
            font-size: 1.4rem;
            cursor: pointer;
            &-dark {
                background: #343434;
                color: #fff;
                border: 1px solid #343434;
            }
        }
    }
    h3 {
        @extend %second-text;
        font-size: 1.4rem;
        text-align: center;
        margin-top: 15px;
        padding: 0 15px;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
    }
}
</style>



// WEBPACK FOOTER //
// ComponentListItem.vue?61724615